import BaseView from './BaseView';
import HomeHeader from '../../components/HomeHeader';
import CollectionTimeline from '../../components/CollectionTimeline';
import Modal from '../../components/Modal';

let view = null;

class TemplateHome extends BaseView {
	constructor(container) {
		super(container);
	}

	init() {

		const homeHeaderElm = this.container.querySelector('[data-home-header]');
		if (homeHeaderElm) {
			this.homeHeader = new HomeHeader(homeHeaderElm);
		}

		const collectionEl = this.container.querySelector('[data-collection]');
		if (collectionEl) {
			this.modal = new Modal(this.container, collectionEl);
			this.collectionTimeline = new CollectionTimeline(collectionEl);
		}
	}

	destroy() {
		this.homeHeader.destroy();
		this.modal.destroy();
	}
}

export default {
	namespace: 'template-home',
	beforeEnter: ({ current, next, trigger }) => {
		view = new TemplateHome(next.container);
		view.init();
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
